const RELOAD_KEY = 'finlay:stale-chunk-reload-at';

/** A second failure this soon after reloading is not a stale tab; stop reloading. */
const RELOAD_COOLDOWN_MS = 10_000;

/**
 * A deploy replaces every hashed chunk under `/assets/`, so a tab opened
 * before it fails the first lazy import it still needs (the Stigg provider,
 * billing). Reloading fetches the new build. Returns false when the tab just
 * reloaded, so a chunk that is really missing reaches the route error page
 * instead of looping.
 */
export const claimStaleChunkReload = (
  storage: Pick<Storage, 'getItem' | 'setItem'>,
  now: number,
) => {
  const lastReloadAt = storage.getItem(RELOAD_KEY);
  if (lastReloadAt !== null && now - Number(lastReloadAt) < RELOAD_COOLDOWN_MS)
    return false;

  storage.setItem(RELOAD_KEY, String(now));
  return true;
};
